// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NaviItems_NavigationItems__nZF1a"};